export enum VelocityUnits {
  MillimetersYear,
  InchesYear,
}
